import { render, staticRenderFns } from "./ImportClient.vue?vue&type=template&id=ef2f722c&"
import script from "./ImportClient.vue?vue&type=script&lang=js&"
export * from "./ImportClient.vue?vue&type=script&lang=js&"
import style0 from "./ImportClient.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports